<div
  *ngFor="let shift of shiftEnum | enumToArray"
  class="availability-shift-toggle-row"
  data-cy="availability-shift-toggle-row"
  (click)="$event.stopPropagation()">
  <div class="toggle-label">
    {{ "shiftsLongName." + shift | i18n | titlecase }}
  </div>
  <app-toggle-buttons
    *ngIf="
            !availability?.shifts ||
              availability?.shifts?.[shiftEnum[shift]] !== availabilityStatusEnum.WORKING;
            else workingHint
          "
    [trueLabel]="('available' | i18n) || 'available' | titlecase"
    [falseLabel]="('unavailable' | i18n) || 'unavailable' | titlecase"
    [value]="
            availability?.shifts && availability?.shifts?.[shiftEnum[shift]]
              ? availability?.shifts?.[shiftEnum[shift]] === availabilityStatusEnum.AVAILABLE
              : undefined
          "
    [disabled]="disabled"
    (valueChange)="
      this.shiftToggled.emit({
        shift: shiftEnum[shift],
        available: $event
      })
    "
    [attr.data-cy]="'shift-toggle-buttons-' + shift"></app-toggle-buttons>
  <ng-template #workingHint>
    <div class="working-hint">
      <app-toggle-buttons
        class="hidden-toggle-buttons"
        [disabled]="disabled"
        [trueLabel]="('available' | i18n) || 'available' | titlecase"
        [falseLabel]="
          ('unavailable' | i18n) || 'unavailable' | titlecase
        "></app-toggle-buttons>
      <div class="working-hint-text">
        {{ "bookedForShift." + $any(shift) | i18n }}
      </div>
    </div>
  </ng-template>
</div>
